export const DISPATCHER = 'dispatcher';
export const DRIVER = 'driver';
export const ADMIN = 'admin';
export const TRAILER = 'trailer';